// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:4000";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nash_token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios.get(`${API}/api/users/me`)
        .then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem("nash_token"); delete axios.defaults.headers.common["Authorization"]; })
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/users/login`, { email, password });
    localStorage.setItem("nash_token", data.token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("nash_token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(null);
  };

  const isAdmin      = () => ["super_admin","admin"].includes(user?.role);
  const isSuperAdmin = () => user?.role === "super_admin";

  return <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isSuperAdmin }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export { API };
